import { render, staticRenderFns } from "./ImportPer.vue?vue&type=template&id=3257a00f&"
import script from "./ImportPer.vue?vue&type=script&lang=js&"
export * from "./ImportPer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports